import React, { Component, PureComponent } from 'react'
import { Icon } from 'semantic-ui-react'

export function CardList({ items = [], emptyText = 'Tuloksia ei löytynyt.', onRemove, onEdit }) {
  return (
    <div className="card-list">
      {items.length ? (
        items.map((i, k) => {
          if (typeof i === 'string') i = { value: i }

          let { label = false, value } = i

          return (
            <div className="card-list-item" key={k}>
              {label ? <div className="card-list-item-label">{label}</div> : null}
              <div className="card-list-item-value">{value}</div>
              {onEdit || onRemove ? (
                <div className="card-list-item-actions">
                  {onEdit ? <button onClick={e => e.preventDefault() & onEdit(i)}>Muokkaa</button> : null}
                  {onRemove ? <button onClick={e => e.preventDefault() & onRemove(i)}>Poista</button> : null}
                </div>
              ) : null}
            </div>
          )
        })
      ) : (
        <div className="card-list-empty">{emptyText}</div>
      )}
    </div>
  )
}

export default function Card({ title = false, icon = false, classTag = false, loading = false, children }) {
  let classes = ['card']
  if (classTag) classes.push(`card--${classTag}`)

  return (
    <div className={classes.join(' ')}>
      {title ? (
        <div className="card-title">
          {icon ? (
            <div className="card-title-icon">
              <Icon name={icon} />
            </div>
          ) : null}
          <div className="card-title-text">
            <span className="ellipsis">{title}</span>
          </div>
        </div>
      ) : null}
      {loading ? (
        <div className="card-loading">
          <i className="i fa fa-spin fa-spinner" />
        </div>
      ) : (
        <div className="card-content">{children}</div>
      )}
    </div>
  )
}
